// extracted by mini-css-extract-plugin
export default {"label":"SWTemplateCompanyTable_label__+pSVf","row":"SWTemplateCompanyTable_row__cEtnv","minusIcon":"SWTemplateCompanyTable_minusIcon__0bEW6"};